<style lang="less">

</style>
<template>
    <div>
        <Drawer :closable="false" placement="right" v-model="drawerVisible" width="50%" :title="drawerTitle">
            <Row>
                <Col>
                <Card :shadow="false">
                    <Row>
                        <Form ref="form" :model="form" :label-width="90" style="position:relative" :rules="formValidate">
                            <Form-item label="条件类型" prop="conditionType" :disabled="isEdit" >
                                <Select v-model="form.conditionType" placeholder="请选择条件类型" @on-change="selectJump" clearable style="width: 600px">
                                    <Option :value = 1>学历</Option>
                                    <Option :value = 2>工作</Option>
                                    <!--<Option value="3">培训</Option>-->
                                    <Option :value = 4>证书</Option>
                                </Select>
                            </Form-item>
                            <FormItem label="条件名称" prop="conditionName">
                                <Input v-model="form.conditionName" style="width:600px"/>
                            </FormItem>
                            <FormItem label="年限" prop="conditionValue" v-if="isCertificate == 2">
                                <InputNumber type="number" v-model="form.conditionValue" style="width:600px"/>
                            </FormItem>
                            <FormItem label="证书" prop="conditionValue2" v-if="isCertificate == 4">
                                <Select v-model="form.conditionValue" style="width:600px">
                                    <Option v-for="item in certificateList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                </Select>
                            </FormItem>
                            <FormItem label="学历" prop="conditionValue3" v-if="isCertificate == 1">
                                <Select v-model="form.conditionValue" style="width:600px">
                                    <Option v-for="item in educationList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                </Select>
                            </FormItem>
                            <Form-item class="br">
                                <Button type="primary" :loading="submitLoading" @click="handelSubmit" style="width:80px">提交</Button>
                                <Button @click="handelCancel">取消</Button>
                            </Form-item>
                            <Spin size="large" fix v-if="loading"></Spin>
                        </Form>
                    </Row>
                </Card>
                </Col>
            </Row>
        </Drawer>
    </div>
</template>
<script>
    import {saveOrEdit, selectCertificateList} from "@/api/bus";
    import uploadInput from "@/views/my-components/flyme/upload-input";
    // 表情包配置 自定义表情可在该js文件中统一修改
    import {sina} from "@/libs/emoji";
    export default {
        name: "activity-drawer",
        components: {
            uploadInput
        },
        data() {
            return {
                isCertificate: 1,
                loading: false, // 表单加载状态
                drawerTitle: "证书报考条件项编辑",
                drawerVisible: false,
                isEdit: false,
                certificateList: [],
                educationList: [
                    {
                        value: 1,
                        label: '初中、中专'
                    },
                    {
                        value: 2,
                        label: '高中、高职'
                    },
                    {
                        value: 3,
                        label: '大专'
                    },
                    {
                        value: 4,
                        label: '其他本科及继续教育本科'
                    },
                    {
                        value: 5,
                        label: '一类本科'
                    },
                    {
                        value: 6,
                        label: '211高校'
                    },
                    {
                        value: 7,
                        label: '海外高校本科'
                    },
                    {
                        value: 8,
                        label: '985'
                    },
                    {
                        value: 9,
                        label: '硕士'
                    },
                    {
                        value: 10,
                        label: '博士'
                    }
                ],
                form: {
                    id: '',
                    conditionName: '',
                    conditionValue: 0,
                    conditionType: 1,
                },
                formValidate: {
                    // 表单验证规则
                    conditionName: [{required: true, message: "条件名称不能为空", trigger: "blur"}],
                    conditionValue: [{required: true,type: 'number', message: "条件值不能为空", trigger: "blur"}],
                },
                submitLoading: false, // 添加或编辑提交状态
            };
        },
        methods: {
            init(){
                this.getCertificates()
            },
            showDrawer(params) {
                if(params){
                    this.isEdit = true
                    this.form.id = params.id
                    this.form.conditionName = params.conditionName
                    this.form.conditionValue = params.conditionValue
                    this.form.conditionType = params.conditionType
                    this.isCertificate = params.conditionType
                }else{
                    this.isEdit = true
                    this.getForm()
                }
                this.drawerVisible = true;
            },
            getForm(){
                this.form.id = ''
                this.form.conditionName = ''
                this.form.conditionValue = 0
                this.form.conditionType = 1
                this.isCertificate = 1
            },
            getCertificates(){
                selectCertificateList().then(res => {
                    if (res.status === true) {
                        this.certificateList = res.data
                    }
                });
            },
            selectJump(){
                if(this.form.conditionType == 4){//选择证书类型
                    this.isCertificate = 4
                    this.form.conditionValue = this.certificateList[0].value
                }else if(this.form.conditionType == 2){
                    this.isCertificate = 2
                    this.form.conditionValue = 0
                }else{
                    this.isCertificate = 1
                    this.form.conditionValue = 1
                }
            },
            handelSubmit() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        this.submitLoading = true;
                        console.info('form：' + JSON.stringify(this.form))
                        // 编辑
                        saveOrEdit(this.form).then(res => {
                            this.submitLoading = false;
                            if (res.status === true) {
                                this.$Message.success("操作成功");
                                this.$parent.getDataList();
                                this.drawerVisible = false;
                            }
                        });
                    }
                });
            },
            handelCancel() {
                this.drawerVisible = false;
            }
        },
        mounted() {
            this.init();
        },
        watch: {

        }
    };
</script>